import { useTranslation } from 'react-i18next';

export default function FeaturesSection() {
  const { t } = useTranslation();

  const features = [
    {
      key: 'time',
      icon: 'ri-timer-line',
      imageSeq: 'feature-time-saving',
    },
    {
      key: 'products',
      icon: 'ri-star-line',
      imageSeq: 'feature-best-products',
    },
    {
      key: 'updates',
      icon: 'ri-loop-left-line',
      imageSeq: 'feature-updates',
    },
  ];

  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 text-center mb-12">
          {t('features.title')}
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {features.map((feature) => (
            <div
              key={feature.key}
              className="bg-background-50 border border-background-200/70 rounded-2xl p-6 md:p-8 text-center hover:border-primary-200 transition-colors duration-300"
            >
              <span className="w-14 h-14 flex items-center justify-center bg-primary-100 text-primary-600 rounded-xl mx-auto mb-5">
                <i className={`${feature.icon} text-2xl`}></i>
              </span>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-3">
                {t(`features.${feature.key}.title`)}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {t(`features.${feature.key}.desc`)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}